import { createSelector } from "@reduxjs/toolkit";

//! Documentid крайней созданной записи
export const selectLastDocId = createSelector(
  [(state: any, modelName: string) => state.gosStrapi.addForms[modelName]?.lastDocId],
  (lastDocId) => lastDocId || null
);

//! ID крайней созданной записи
export const selectLastAddedId = createSelector(
  [(state: any, modelName: string) => state.gosStrapi.addForms[modelName]?.lastAddedId],
  (lastAddedId) => lastAddedId || null
);

//! ID крайней обновленной записи
export const selectLastUpdatedId = createSelector(
  [(state: any, modelName: string) => state.gosStrapi.addForms[modelName]?.lastUpdatedId],
  (lastUpdatedId) => lastUpdatedId || null
);

//! Проверяет, был ли последний добавленный элемент создан этим компонентом
export const selectIsLastAddedByCreator = createSelector(
  [(state: any, modelName: string, creatorId: string) => {
    const modelData = state.gosStrapi.addForms[modelName];
    return modelData?.lastAddedCreatorId === creatorId;
  }],
  (isCreator) => isCreator
);